import React from 'react';
import ReactDOM from 'react-dom';
import fetch from 'node-fetch';
import { connect } from 'react-redux';
import VButton from '../VButton.jsx';
import { appContext } from '../../util/decorators';
import PageWithoutSidebars from '../Page/PageWithoutSidebars.jsx';

const mapStateToProps = state => ({
  country: state.country,
});

@connect(mapStateToProps)
@appContext
export default class Login extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.email).focus();
  }

  submit(event) {
    event.preventDefault();
    const email = this.refs.email.value;
    this.refs.email.value = '';

    fetch('https://docs.google.com/forms/d/1pgGJbQxoWTUz1cCspbCQaxbH7x-1Xh6u6RUEAsPJtwQ/formResponse',
      {
        method: 'POST',
        body: 'entry.1589530550=' + encodeURIComponent(email) + '&entry.1581234222=' + this.props.country,
        headers: {
          Accept: 'application/xml, text/xml, */*',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    ).catch(() => {
      // will always fail because of cross origin constraints
      this.setState({ showDoneMessage: true });
    });
  }

  render() {
    const t = this.context.app.t;

    return (
      <PageWithoutSidebars>
        <div className="login">

          { this.state.showDoneMessage &&
            <div className="highlight-box login-complete">
              <div className="section">{t('Login.registration_complete')}</div>
            </div>
            }

          <h2>{t('Login.heading')}</h2>

          <p>{t('Login.coming_soon')}</p>

          <div className="inner">
            <form onSubmit={event => this.submit(event)}>
              <fieldset>
                <label htmlFor="email" className="structural">{t('Login.username')}</label>
                <input className="input-field" id="email" name="email" type="email" placeholder={t('Login.email')} ref="email" required />
              </fieldset>
              <VButton type="primary">{t('Login.notify_me')}</VButton>
            </form>
          </div>
        </div>
      </PageWithoutSidebars>
    );
  }
}

Login.propTypes = {
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Account/Login.jsx